<template>
    <div>
        <v-uploader :multiple="true" @done="uploadDone"></v-uploader>
    </div>
</template>
<script>
export default {
    props: ["form"],
    methods: {
        uploadDone(files) {
            if (files && Array.isArray(files) && files.length) {
                this.form.files = files;
            }
        }
    }
};
</script>
